const Resources = {

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Buildings',
            href:   '/buildings',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Non-EVS Personnel',
            href:   '/building-personel',
            arrow:  " ",
        },
    ],

    table_headers: [
        { 
          text:     'First Name',  
          align:    'start', 
          value:    'name',
        //   type:     'link',
        },
        {   
            text:   'Last Name',
            value:  'last_name'
        },
        { 
          text:     'Cost Center Name',
          value:    'cost_center'
        },
        { 
            text:   'Department Name',
            value:  'cost_center_department'
        },
        { 
            text:   'Ext',
            value:  'ext'
        },
        { 
            text:   'Manager',
            value:  'is_manager',
            type:   'boolean'
        },
    ],

    excel_file_headers: {
        'Cost Center Name': 'cost_center_id',
        'Department Name': 'cost_center_department_id',
        'First Name': 'name',
        'Last Name': 'last_name',
        'Email': 'email',
        'Ext': 'ext',
        'Manager (true or false)': 'is_manager'
    },

    excel_fields_required: {
        cost_center_id:             true,
        cost_center_department_id:  true,
        name:                       true,
        last_name:                  true,
        email:                      true,
        ext:                        false,
        is_manager:                 false,
    },

    empty_format_data: [
        {
            cost_center_id:             '',
            cost_center_department_id:  '',
            name:                       '',
            last_name:                  '',
            email:                      '',
            ext:                        '',
            is_manager:                 false,
        },
    ],

    helps: [
        {
            label: '¿How to add a Non-EVS Personnel?', 
            instruction: `https://scribehow.com/embed/Add_Non-EVS_Personnel__a9Kz2mENQleOa0r8nhgvDQ?as=scrollable`
        },
        {
            label: '¿How to delete Non-EVS Personnel?', 
            instruction: `https://scribehow.com/embed/How_To_Delete_Non-EVS_Personnel__zeOaenjUSwy5TsBHPUW4jw?as=scrollable`
        },
    ]

}

export default Resources